import { gql } from '@apollo/client';

const GET_LOCALE = gql`
    query GetLocale {
        appLocale @client
    }
`;

export default GET_LOCALE;
